import React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

// Mobile-only sticky title row: back arrow (optional) + truncating title +
// a single icon-only primary action. Self-hides at sm+ via CSS display so
// pages can mount it unconditionally alongside their existing desktop header
// (which they gate the other way, e.g. sx={{ display: { xs: 'none', sm: 'flex' } }}).
export default function MobilePageHeader({ title, subtitle, icon, onBack, action, sx }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (onBack) onBack();
    else navigate(-1);
  };

  return (
    <Box
      sx={{
        display: { xs: 'flex', sm: 'none' },
        alignItems: 'center',
        gap: 1,
        mb: 1.5,
        ...sx,
      }}
    >
      {onBack !== undefined && (
        <IconButton size="small" onClick={handleBack} edge="start" sx={{ ml: -0.5 }}>
          <ArrowBackIcon fontSize="small" />
        </IconButton>
      )}
      {icon}
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="h6"
          fontWeight="bold"
          noWrap
          sx={{ fontSize: '1.05rem' }}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" noWrap sx={{ display: 'block' }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {action && (
        <Tooltip title={action.label || ''}>
          <IconButton
            color={action.color || 'primary'}
            onClick={action.onClick}
            sx={{ flexShrink: 0 }}
            aria-label={action.label}
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      )}
    </Box>
  );
}
